import React, { useState, createContext, useContext, useEffect } from "react";
import { delSessionFunc } from "../api/func/userFunc";
import { useNavigate } from "react-router-dom";
export const AppContext = createContext({
  isLoggedIn: false,
  user: null,
  logout: () => {},
  setUser: () => {},
});

export const useApp = () => useContext(AppContext);

export const AppProvider = ({ children }) => {
  let navigate = useNavigate();

  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [user, setUser] = useState(null);

  const login = async (userData) => {
    // [도메인 로고 꼬임 수리 2026-08-08] 씨네체인/영화거래소를 번갈아 쓰면 이전 도메인 user가 남아
    //   로고가 틀리게 뜸(씨네체인 로그인인데 영화거래소 로고). 로그인 시 이전 잔재를 확실히 제거 후
    //   서버가 준 새 userData(정확한 domain)로 덮어쓴다.
    try { sessionStorage.removeItem("user"); } catch (e) {}
    sessionStorage.setItem("user", JSON.stringify(userData));
    setIsLoggedIn(true);
    setUser(userData);
    navigate("/"); // 로그인 후 페이지로 리디렉션
    // console.log(`## login end ##`);
  };

  const logout = async () => {
    // console.log(`## logout start ##`);
    const storedUser = await JSON.parse(sessionStorage.getItem("user"));
    console.log(storedUser);
    await delSessionFunc(storedUser.id);
    sessionStorage.removeItem("user");

    setIsLoggedIn(false);
    setUser(null);
    // console.log(`## logout end ##`);
  };

  return (
    <AppContext.Provider
      value={{ isLoggedIn, user, login, logout, setIsLoggedIn, setUser }}
    >
      {children}
    </AppContext.Provider>
  );
};
